import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Service Group Name',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Cut-off Time',
    field: 'cutOffTime',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    searchable: true
  },
];
